
import React from 'react'
import { SocialAccountCreator } from 'types/social-account'
import userImgPlaceholder from "assets/images/users/user-dummy-img.jpg"
import InstagramLogoIcon from 'assets/icons/InstagramLogoIcon'
import FollowersIcon from 'assets/icons/mono/FollowersIcon'
import { formatNumber } from 'utils/helpers'

const CreatorCard: React.FC<{creator: SocialAccountCreator}> = ({creator}) => {
  return (
    <div className='creator-card h-100'>
        <div className="creator-card__profile_picture">
            <img src={creator?.social_account?.profile_picture_url ?? userImgPlaceholder} alt={creator.social_account.handle}/>
        </div>
        <div className="creator-card__details">
            <div className="d-flex align-items-center justify-content-between gap-2">
                <div className="d-flex flex-column">
                    <span className="creator-card__name">
                        {creator.social_account.name}
                    </span>
                    <span className="creator-card__handle">
                        <InstagramLogoIcon />{creator.social_account.handle}
                    </span>
                </div>
                <div className="d-flex flex-column">
                    <span className="creator-card__followers_count">
                        <FollowersIcon /> <span>{formatNumber(creator.social_account.followers_count)}</span>
                    </span>
                    <span className="creator-card__folowers_label">
                        Followers
                    </span>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CreatorCard